export const CLEAR_PROFILE_ATTEMPT = 'admin/cache/CLEAR_PROFILE_ATTEMPT'
export const CLEAR_PROFILE_SUCCESS = 'admin/cache/CLEAR_PROFILE_SUCCESS'
export const CLEAR_PROFILE_FAILURE = 'admin/cache/CLEAR_PROFILE_FAILURE'

export const RESET = 'admin/cache/RESET'
